import { AlertTriangle } from "lucide-react";

export const SafetyAlerts = ({ warnings, t }) => (warnings.length ? (
  <div className="load-safety" data-testid="safety-alerts">
    {warnings.map((w, k) => (
      <div key={k} className={`drop-warn drop-warn-${w.level === "high" ? "danger" : "caution"} load-safety-item`} role="alert" data-testid={`safety-warning-${k}`}>
        <AlertTriangle size={22} />
        <div><b className="drop-warn-head">{t(w.level === "high" ? "UNSAFE ORDER" : "CAUTION")} · {w.title}</b><p className="drop-warn-text">{w.msg}</p></div>
      </div>
    ))}
  </div>
) : null);
